import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { Router, ActivatedRoute } from "@angular/router";
import { StatisticFilterModel, StatisticsModel, StatisticsService } from "@bt/core";
import { FilterElementsModel } from "@bt/core"
import { DomainModel, DomainService } from "@bt/core";
import { NotifierService } from "angular-notifier";
import * as $ from 'jquery';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { stringify } from '@angular/core/src/util';


@Component({
  selector: 'statistitic.group.date.component',
  templateUrl: './statistitic.group.date.component.html',
  styleUrls: ['./statistitic.group.date.component.scss']
})
export class StatisticsGroupDateComponent extends BaseComponent implements OnInit {

  faTimes = faTimes;


  public isResponsed: boolean = false;
  public hasInfo: boolean = false;
  public isfiltertokenNames: boolean = false;

  public defaultDate: any;
  public filter: StatisticFilterModel;
  //public browsers: any = [];
  public sorting: any = [];
  public devices: any = [];
  public tokenNames: any = [];
  //public countries: any = [];
  public domains: any = [];
  public filterElements: FilterElementsModel;
  public config: any;
  public statistics: StatisticsModel[];
  notifier: any;
  public domainId: string = "0";


  constructor(
    private domainService: DomainService,
    private statisticsService: StatisticsService,
    notifierService: NotifierService,
  ) {
    super();

    this.domains = [];
    this.notifier = notifierService;

    this.config = {
      labelField: 'label',
      valueField: 'value',
      searchField: 'label',
      highlight: false,
      create: false,
      persist: true,
      //plugins: ['dropdown_direction', 'remove_button'],
      dropdownDirection: 'down',
      maxItems: 1
    };

    // this.browsers = [
    //   { value: "Chrome", name: "Google", code: "", label: "Google" },
    //   { value: "Yandex", name: "Yandex", code: "", label: "Yandex" },
    //   { value: "Opera",  name: "Opera",  code: "", label: "Opera" },
    // ];

    this.sorting = [
      { value: 0, name: "Дата", code: "", label: "Дате" },
      { value: 1, name: "Домен", code: "", label: "Доменам" },
      { value: 2, name: "Страна", code: "", label: "Странам" },
      { value: 3, name: "ОС", code: "", label: "ОС" },
      { value: 4, name: "Устройство", code: "", label: "Устройствам" },
      { value: 5, name: "Токены", code: "", label: "Токенам" },
      { value: 6, name: "Браузеры", code: "", label: "Браузерам" },
      { value: 7, name: "Название пуша", code: "", label: "Названию пуша" },
    ];

    this.devices = [
      { value: -1, name: "Все устройства", code: "", label: "Все устройства" },
      { value: 0, name: "Компьютер", code: "", label: "Компьютер" },
      { value: 1, name: "Смартфон", code: "", label: "Смартфон" },
      { value: 2, name: "Планшет", code: "", label: "Планшет" },
    ];

    // this.countries = [
    //   { value: "Europe/Moscow", name: "Россия",  code: "", label: "Россия" },
    //   { value: 1,               name: "США",     code: "", label: "США" },
    //   { value: 2,               name: "Канада",  code: "", label: "Канада" },
    // ];


  }

  ngOnInit() {



    this.filterElements = new FilterElementsModel;

    this.statistics = new Array<StatisticsModel>();

    this.filter = new StatisticFilterModel;
    this.filter.groupBy = 0;
    this.filter.device = -1;
    this.filter.browser = "0";
    this.filter.os = "0";
    this.filter.country = "0";
    this.filter.domainId = 0;
    this.filter.groupByTokenName = "0";
    var t = this;

    this.GetDomains();
    this.GetFilterElements();



    this.filter.BeginRegDate = null;

    var dp1 = (<any>window).$('.regDate').datepicker({
      multipleDates: true,

      autoClose: true,
      onSelect: function (fd, dates, inst) {
        if (dates) {
          t.defaultDate = dates[0];
          t.filter.BeginRegDate = dates[0];
          if (dates.length > 1) {
            t.filter.EndRegDate = dates[1];
          }
          else {
            t.filter.EndRegDate = null;
          }
        }

      }

    }).data('datepicker');

    var resizeTimer;

    var positionCalendarTopBottom = function () {
      var dp1Update = (<any>window).$('.regDate').datepicker().data('datepicker');

      if (dp1Update) {
        if ($(window).innerWidth() < 768) {
          dp1Update.update({
            position: "top left",
          });
        }
        else {
          dp1Update.update({
            position: "bottom left",
          });
        }
      }

    }

    $(window).on('resize', function (e) {

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionCalendarTopBottom, 250);

    });

    setTimeout(positionCalendarTopBottom, 250);

    (<any>window).$(".regDate").keyup(function () {
      if (!this.value || this.length < 1) {
        t.filter.EndRegDate = null;
        t.filter.BeginRegDate = null;
      }
    });

    (<any>window).$('.bitmap').on('scroll', function () {
      dp1.update();
    })

  }

  public sortBy(group: number): string {
    if (group == -1) return "Дата отправки"; else
      if (group == 0) return "Дата доставки"; else
        if (group == 1) return "Домен"; else
          if (group == 2) return "Страна"; else
            if (group == 3) return "ОС"; else
              if (group == 4) return "Устройство"; else
                if (group == 5) return "Токены"; else
                  if (group == 6) return "Браузеры"; else
                    if (group == 7) return "Название пуша"; else
                      return "";
  }

  GetDomains() {
    this.setLoading(true);
    this.domainService.GetDomains()
      .then((resp) => {
        this.domains.push({ label: "Все сайты", value: '0' });
        for (let domain of resp.data) {
          this.domains.push({ label: domain.name, value: domain.id });
        }
        this.setLoading(false);
      })
      .catch((error) => {
        this.notifier.notify('error', "Ошибка при получении списка доменов");
        this.setLoading(false);
      });
  }

  GetFilterElements() {
    this.setLoading(true);
    this.statisticsService.GetFilterElements()
      .then((resp) => {
        this.filterElements.browser.push({ label: "Все браузеры", value: "0" });
        this.filterElements.country.push({ label: "Все страны", value: "0" });
        this.filterElements.os.push({ label: "Все ОС", value: "0" });
        this.filterElements.tokens.push({ label: "Все токены", value: "0" });

        for (let browser of resp.data.browser) {
          this.filterElements.browser.push({ label: browser, value: browser });
        }

        for (let country of resp.data.country) {
          this.filterElements.country.push({ label: country, value: country });
        }

        for (let os of resp.data.os) {
          this.filterElements.os.push({ label: os, value: os });
        }
        for (let tk of resp.data.tokens) {
          this.filterElements.tokens.push({ label: tk, value: tk });
        }
        this.setLoading(false);
      })
      .catch((error) => {
        this.notifier.notify('error', "Ошибка при получении элементов фильтра");
        this.setLoading(false);
      });


  }

  public loadStatistic() { //метод для обращения к сервису

    var t = this;
    t.setLoading(true);
    /////////////////////костыль для того что бы время на бек приходило без смещения на 3 часа
    // if (t.filter.BeginRegDate != null && t.filter.BeginRegDate instanceof Date) {
    //   try {

    //     t.filter.BeginRegDate = (<any>t).filter.BeginRegDate.toDateString();

    //   }
    //   catch (e) {

    //     t.filter.BeginRegDate = null;
    //     t.setLoading(false);
    //     t.loadStatistic();
    //   }

    // }

    // if (t.filter.EndRegDate != null && t.filter.EndRegDate instanceof Date)
    //   t.filter.EndRegDate = (<any>t).filter.EndRegDate.toDateString();

    // if (t.filter.groupBy == 5) {
    //   if (!t.isfiltertokenNames) {
    //     t.isfiltertokenNames = true;
    //     t.filter.groupByTokenName = "0"
    //   }
    // }
    // else
    //   t.isfiltertokenNames = false;

    /////////////////////////

    t.filter.statsType = 3;
    t.filter.domainId = parseFloat(t.domainId);

    t.statisticsService.GetStatisticByDate(t.filter)
      .then((resp) => {
        t.hasInfo = resp.data.length != 0;
        t.statistics = resp.data;
        //this.loadTotalUsers();
        t.isResponsed = true;
        t.setLoading(false);
      })
      .catch((error) => {
        t.hasInfo = false;
        t.isResponsed = true;
        console.error(error.error);

        t.setLoading(false);
      });
  }

  public clearRegDate() {
    var t = this;
    (<any>window).$(".regDate").val("");
    t.filter.EndRegDate = null;
    t.filter.BeginRegDate = null;
    (<any>window).$('.regDate').datepicker().data('datepicker').clear();
  }

  GetStatistics() {
    this.setLoading(true);
    this.statisticsService.GetStatisticSubscriptions(this.filter)
      .then((resp) => {
        this.statistics = resp.data;
        this.setLoading(false);
      })
      .catch((error) => {
        this.notifier.notify('error', "Ошибка подгрузки данных");
        this.setLoading(false);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/statistitic.group.date/statistitic.group.date.component.ts